import {Table as UxTable, Card, Form} from '@deere/ux.uxframe-react'
import React from 'react'
import {getAnswerLabel, getTranslation, findAnswerIndex} from '../../utils/utils'
import TableCustomReview from './TableCustomReview'
import { DEERE_DEMAND, QUESTION_PROPRIETARY, QUESTION_TYPES } from '../../utils/surveyLiterals'
import PropiertaryInfReview from './PropiertaryInfReview'

export default function FlexibilityReviewSection({sectionSurvey,answers}){
    
    if(!sectionSurvey)
        return <></>

    const questions = sectionSurvey.questions.filter(qu => qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1)
    const propQuestion = sectionSurvey.questions.filter(qu => qu.text === QUESTION_PROPRIETARY)[0];

    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, answers) >= 0 ? answers[findAnswerIndex(propQuestion.id, answers)].answer : '' : '';
    const questionTitle = questions ? questions.find(q => q.type === QUESTION_TYPES.OPEN_TITLE) : null;
    const listQuestions = questions ? questions.filter(q => q.type === QUESTION_TYPES.TABLE_BS) : null;
    const colNames = listQuestions && Array.isArray(listQuestions) && listQuestions[0] && listQuestions[0].dependentQuestions ? listQuestions[0].dependentQuestions.map(q => getTranslation(q, 'text')) : [];
    const deereDemandHeader = questions ? questions.find(q => q.type === DEERE_DEMAND) : null;

    function createRow(q,pad){
        let  answer =  getAnswerLabel(q, answers);
        if(q.idQuestionDepends && (q.idQuestionDepends) > 0){
            return answer === '-'?null:<Form.Group className={ pad?'mb-4 pl-4':''}>
                                        <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                                        <h6>{answer}</h6>
                                    </Form.Group>
        }else{
            return <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                    <h6>{answer}</h6>
                </Form.Group>
        }
    }

    function createCheckRow(q){
        let labels = getAnswerLabel(q,answers);
        labels = labels === '-' || labels === undefined?null:labels;
        return  labels?<Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                    {labels?labels.map(lab => <li key={lab}>{lab}</li>):''}
                </Form.Group>:<Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                    <h6>-</h6>
                </Form.Group>;
           
    }

    const createTableRow = (q, index) => {
        return (
            <tr key={index}>
              <td className="p-1">{getTranslation(q, "text")}</td>
              {q.dependentQuestions
                .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                .map((dq) => (
                  <td key={dq.id} className="p-1">
                    {dq.type === QUESTION_TYPES.PERC_SALES ? getAnswerLabel(dq, answers) : <></>}
                    {dq.type === QUESTION_TYPES.OPTION ? getAnswerLabel(dq, answers) : <></>}
                  </td>
                ))}
            </tr>
        );
    };

    return (<div>        
                {propComments? <PropiertaryInfReview section={sectionSurvey} answer={propComments}/>:null} 
                {!propComments?<Card>
                    <Card.Body>
                    <Card.Title className='pb-3'>
                        {getTranslation(sectionSurvey,'description')}
                    </Card.Title>
                    {questions?questions.map((q,idx) => <Form.Row className="d-block mb-4" key={idx}>
                        {(q.type === QUESTION_TYPES.OPEN || q.type === QUESTION_TYPES.RADIO) && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0)?createRow(q,(idx === 2)):null}
                        {q.type === QUESTION_TYPES.CHECK? createCheckRow(q):null}
                        {q.type === QUESTION_TYPES.OPTION && (idx !== 1)?createRow(q,idx,false):null}
                        {q.type === QUESTION_TYPES.FLEX_TITLE?<TableCustomReview questions={questions} answers={answers}/>:null}
                        </Form.Row>):<></>}
                        {listQuestions && listQuestions.length > 0 &&
                            <UxTable striped hover size="sm">
                                <caption>{getTranslation(questionTitle, "text")}</caption>
                                <thead>
                                    <tr>
                                    {deereDemandHeader ? <th className="p-1" scope="col" style={{width: "60%"}}>{getTranslation(deereDemandHeader, "text")}</th> : <th className="p-1" scope="col" style={{width: "60%"}}></th>}
                                    {colNames ? (
                                        colNames.map((qt) => (
                                        <th scope="col" className="p-1 text-center" key={qt} style={{width: "40%"}}>
                                            {qt}
                                        </th>
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                    </tr>
                                </thead>
                                <tbody>{listQuestions.map((data, index) => createTableRow(data, index))}</tbody>
                            </UxTable>
                        }
                    </Card.Body>
                </Card>:null
                }
                <br />
            </div>)
}   